export * from './placement.type';
export * from './position';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/release/common/tooltip/position/index.js
// module id = 850
// module chunks = 3